import React from "react"

const ProcessingDate = () => {
  return <div>Thống kê theo hạn xử lý</div>
}

export default ProcessingDate
